import React from "react";
import {
  Alert,
  AlertContainer,
  Icon,
  IconSettings,
} from "@salesforce/design-system-react";

class ErrorAlert extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: true,
    };
  }

  render() {
    return (
      <IconSettings iconPath="/icons">
        {this.state.isOpen ? (
          <AlertContainer>
            <Alert
              dismissible
              icon={<Icon category="utility" name="error" />}
              labels={{
                heading: this.props.message,
                headingLink: this.props.linkText,
              }}
              onClickHeadingLink={() => {
                window.open(this.props.link, "_blank", "noopener,noreferrer");
              }}
              onRequestClose={() => {
                this.setState({ isOpen: false });
              }}
              variant="error"
            />
          </AlertContainer>
        ) : null}
      </IconSettings>
    );
  }
}

export default ErrorAlert;
